import store from '@/store';
import { Shortcut } from '@/types/shortcut';

export default class ShortcutsComponent {
	setItemsChecked(shortcut: Shortcut): void {
		store.actions.setItemsChecked(shortcut);
	}
}
